import React from 'react';

const traitIcons = {
  'Pressure Resistant': '🛡️',
  'Heat Resistant': '🔥',
  'Anaerobic': '🦠',
  'Light Sensitive': '☀️',
};

const traitColors = {
  'Pressure Resistant': '#60A5FA',
  'Heat Resistant': '#F87171',
  'Anaerobic': '#A3E635',
  'Light Sensitive': '#FBBF24',
};

export default function FlexForceSiteInfoCard() {
  return (
    <div
      className="rounded-xl shadow-md p-5 mb-4"
      style={{
        background: 'linear-gradient(120deg, #FEF9C3 90%, #FDE68A 100%)',
        border: '1.5px solid #FDE68A',
        minWidth: 260,
        maxWidth: 320,
        color: '#444',
        fontFamily: 'inherit',
      }}
    >
      <div className="font-bold text-lg mb-2" style={{ color: '#b45309', letterSpacing: '0.01em' }}>Flex Force</div>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>ATTRIBUTES</div>
      <ul className="mb-3 text-sm">
        <li><span className="font-medium">Movement:</span> <span style={{ color: '#2563eb' }}>4 – 8</span></li>
        <li><span className="font-medium">Size:</span> <span style={{ color: '#2563eb' }}>2 – 6</span></li>
        <li><span className="font-medium">Flexibility:</span> <span style={{ color: '#2563eb' }}>5 – 9</span></li>
      </ul>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>TRAITS</div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Desired:</span>{' '}
        <span style={{ color: traitColors['Pressure Resistant'], fontWeight: 600 }}>
          {traitIcons['Pressure Resistant']} Pressure Resistant
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Undesired:</span>{' '}
        <span style={{ color: traitColors['Anaerobic'], fontWeight: 600 }}>
          {traitIcons['Anaerobic']} Anaerobic
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">All traits:</span>{' '}
        {['Pressure Resistant', 'Heat Resistant', 'Anaerobic', 'Light Sensitive'].map(trait => (
          <span key={trait} style={{ color: traitColors[trait], marginRight: 8, fontWeight: 600 }}>
            {traitIcons[trait]} {trait}
          </span>
        ))}
      </div>
    </div>
  );
} 